import { ca } from '@cian/analytics';
import { TDeviceType } from '@cian/ui-kit';
import { getSiteType } from '../../utils/getSiteType';
import { TRecommendation } from '../../types/recommendation';

export function trackWriteMessageClick(offer: TRecommendation, deviceType: TDeviceType) {
  ca('eventSite', {
    action: 'send_message',
    category: 'card',
    label: offer.gaLabel,
    name: 'oldevent',
    page: {
      pageType: 'Recommendations',
      siteType: getSiteType(deviceType),
      extra: {
        reason: 'WorkHoursPopup',
      },
    },
    products: [
      {
        id: offer.offerId,
        offerType: 'offer',
      },
    ],
  });
}

export function trackPopupShown(offer: TRecommendation) {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'work_hours',
    label: 'popup',
    name: 'oldevent',
    products: [
      {
        id: offer.offerId,
        offerType: 'offer',
      },
    ],
  });
}

export function trackCallAnyway(offer: TRecommendation) {
  ca('eventSite', {
    action: 'click_callbutton',
    category: 'work_hours',
    label: 'popup',
    name: 'oldevent',
    products: [
      {
        id: offer.offerId,
        offerType: 'offer',
      },
    ],
  });
}
